export default "<a [routerLink]=\"['/login']\">\r\n\r\n    <img src=\"assets/img/onboard.jpg\" alt=\"\" style=\"width:100%;height:100%\">\r\n\r\n</a>"